import { useState, useEffect, useCallback } from "react";
import { fetchLoginData } from "../utils/userUtils";
import { extractDomain } from "../utils/utils";

interface IProps {
  isRecallGetUser?: boolean;
  isClient?: boolean;
  middleware: string;
  page_name: string;
  shouldSendPrevUrl?: boolean;
}

const useUserDetails = ({
  isRecallGetUser = false,
  isClient = false,
  middleware,
  page_name,
  shouldSendPrevUrl = true,
}: IProps) => {
  const [userDetails, setUserDetails] = useState<any>(null);

  const fetchUserDetails = useCallback(
    async (forceFetch = false) => {
      try {
        if(typeof window === "undefined") return;
        const stored = sessionStorage.getItem("userDetails");

        if (!stored || forceFetch) {
          const data = await fetchLoginData({ middleware, page_name });

          if (data && Object.keys(data).length > 0) {
            setUserDetails(data);
            sessionStorage.setItem("userDetails", JSON.stringify(data));
            sessionStorage.setItem("initialVisit", "true");
          }
        } else {
          setUserDetails(JSON.parse(stored));
        }
      } catch (err) {
        console.error("Error fetching user details:", err);
        // redirect to login page
        let url = extractDomain();
        if(shouldSendPrevUrl) {
          url = `${url}?prevUrl=${encodeURIComponent(window.location.href)}`;
        }
        window.location.href = url;
      }
    },
    [middleware, page_name]
  );

  useEffect(() => {
    if (!isClient) return;

    const isFirstVisit = !sessionStorage.getItem("initialVisit");
    fetchUserDetails(isFirstVisit || isRecallGetUser);

    const intervalId = setInterval(
      () => fetchUserDetails(true),
      30 * 60 * 1000
    );
    return () => clearInterval(intervalId);
  }, [isClient, isRecallGetUser, fetchUserDetails]);

  return { userDetails };
};

export default useUserDetails;
